import { alpha } from '@mui/material/styles';

// ----------------------------------------------------------------------

function createGradient(color1, color2) {
  return `linear-gradient(to bottom, ${color1}, ${color2})`;
}

// SETUP COLORS
const GREY = {
  0: '#FFFFFF',
  100: '#F9FAFB',
  200: '#F4F6F8',
  300: '#DFE3E8',
  400: '#C4CDD5',
  500: '#919EAB',
  600: '#637381',
  700: '#454F5B',
  800: '#212B36',
  900: '#161C24',
  500_8: alpha('#919EAB', 0.08),
  500_12: alpha('#919EAB', 0.12),
  500_16: alpha('#919EAB', 0.16),
  500_24: alpha('#919EAB', 0.24),
  500_32: alpha('#919EAB', 0.32),
  500_48: alpha('#919EAB', 0.48),
  500_56: alpha('#919EAB', 0.56),
  500_80: alpha('#919EAB', 0.8),
};

const PRIMARY = {
  lighter: '#bcb5be',
  light: '#9c959e',
  main: '#736D75',
  dark: '#5f5961',
  darker: '#403b42',
  contrastText: '#fff',
};

const SECONDARY = {
  lighter: '#5b678b',
  light: '#33426f',
  main: '#00134b',
  dark: '#000d34',
  darker: '#000924',
  contrastText: '#fff',
};

const INFO = {
  lighter: '#D0F2FF',
  light: '#74CAFF',
  main: '#1890FF',
  dark: '#0C53B7',
  darker: '#04297A',
  contrastText: '#fff',
};

const SUCCESS = {
  lighter: '#4CAF50',
  light: '#43A047',
  main: '#388E3C',
  dark: '#2E7D32',
  darker: '#1B5E20',
  contrastText: '#fff',
};

const WARNING = {
  lighter: '#FFF7CD',
  light: '#FFE16A',
  main: '#FFC107',
  dark: '#B78103',
  darker: '#7A4F01',
  contrastText: GREY[800],
};

const ERROR = {
  lighter: '#FFE7D9',
  light: '#FFA48D',
  main: '#FF4842',
  dark: '#B72136',
  darker: '#7A0C2E',
  contrastText: '#fff',
};

const WHITE = {
  lighter: '#fff',
  light: '#fff',
  main: '#fff',
  dark: '#fff',
  darker: '#fff',
  contrastText: '#000',
};

const BLACK = {
  lighter: '#000',
  light: '#000',
  main: '#000',
  dark: '#000',
  darker: '#000',
  contrastText: '#fff',
};

const GRADIENTS = {
  primary: createGradient(PRIMARY.light, PRIMARY.main),
  info: createGradient(INFO.light, INFO.main),
  success: createGradient(SUCCESS.light, SUCCESS.main),
  warning: createGradient(WARNING.light, WARNING.main),
  error: createGradient(ERROR.light, ERROR.main),
};

const CHART_COLORS = {
  violet: ['#826AF9', '#9E86FF', '#D0AEFF', '#F7D2FF'],
  blue: ['#2D99FF', '#83CFFF', '#A5F3FF', '#CCFAFF'],
  green: ['#2CD9C5', '#60F1C8', '#A4F7CC', '#C0F2DC'],
  yellow: ['#FFE700', '#FFEF5A', '#FFF7AE', '#FFF3D6'],
  red: ['#FF6C40', '#FF8F6D', '#FFBD98', '#FFF2D4'],
};

const darkModePalette = () => ({
  divider: GREY[500_24],
  text: { primary: GREY[100], secondary: GREY[200], disabled: GREY[500] },
  background: { paper: '#1e1e1e', default: '#000000', neutral: GREY[900] },
  mode: 'dark',
  neutral: { ...WHITE },
  action: {
    active: GREY[600],
    hover: GREY[900],
    selected: GREY[500_16],
    disabled: GREY[500_80],
    disabledBackground: GREY[500_24],
    focus: GREY[500_24],
    hoverOpacity: .05,
    disabledOpacity: 0.48,
  },
});

const lightModePalette = () => ({
  divider: GREY[500_24],
  text: { primary: GREY[800], secondary: GREY[600], disabled: GREY[500] },
  background: { paper: '#F5F5F5', default: GREY[100], neutral: GREY[200] },
  mode: 'light',
  neutral: { ...BLACK },
  action: {
    active: GREY[600],
    hover: GREY[500_8],
    selected: GREY[500_16],
    disabled: GREY[500_80],
    disabledBackground: GREY[500_24],
    focus: GREY[500_24],
    hoverOpacity: 0.08,
    disabledOpacity: 0.48,
  },
});

const standardPalette = {
  common: { black: '#000', white: '#fff' },
  primary: { ...PRIMARY },
  secondary: { ...SECONDARY },
  info: { ...INFO },
  success: { ...SUCCESS },
  warning: { ...WARNING },
  error: { ...ERROR },
  grey: GREY,
  gradients: GRADIENTS,
  chart: CHART_COLORS,
  divider: GREY[500_24],
  // text: { primary: GREY[800], secondary: GREY[600], disabled: GREY[500] },
  // background: { paper: '#fff', default: GREY[100], neutral: GREY[200] },
  // mode: 'dark',
  // action: {
  //   active: GREY[600],
  //   hover: GREY[500_8],
  //   selected: GREY[500_16],
  //   disabled: GREY[500_80],
  //   disabledBackground: GREY[500_24],
  //   focus: GREY[500_24],
  //   hoverOpacity: 0.08,
  //   disabledOpacity: 0.48,
  // },
};

const palette = (mode) => {
  const pal = mode === 'light' ? lightModePalette() : darkModePalette();
  return { ...standardPalette, ...pal };
};

export default palette;
